import { vxm } from '@/store.vuex';
import { escapeUrlParameter } from '../Commons/UrlUtils';
import { Facility } from './../../models/jobs/facility';
import {
    JOB_PAY_UOM_HOUR,
    JOB_PAY_UOM_TIMESLOT,
    JOB_PAY_UOM_YEAR,
    JOB_PAY_UOM_WEEK,
    JOB_PAY_UOM_DAY,
    JOB_PAY_UOM_MONTH,
} from './MyJobsConstants';


// Create the job title slug
export const createJobTitleCitySlug = (jid: string, jTitle: string, facility: Facility): string => {
    // Validate the facility and take the city parameter
    const city = facility.city ? facility.city.trim() : facility.city;
    let jobTitleSlug = escapeUrlParameter(jTitle.toLowerCase());
    // Validate and concat the city to the job url
    if (city !== null && city.length > 0) {
        jobTitleSlug = jobTitleSlug.concat('-').concat(escapeUrlParameter(city));
    }
    // Concat the job id and return the job url
    return jobTitleSlug.concat('-').concat(jid);
}

export const getJobIDFromJobURL = (url): number => {
    if (!isNaN(url)) return parseInt(url, 10);
    // Return the JobID captured from the generic url
    const params = url.split('-');
    return parseInt(params[params.length - 1], 10);
}

// Validate Job Placement Type and return the right text
export const getJobTypeText = (job): string => {
    if (job.candidatePlacementTypeText) {
        return job.candidatePlacementTypeText;
    }
    if (job.jobPostingTypeText) {
        return job.jobPostingTypeText
    }
    if (job.jobPostingType === '01') {
        return 'Full time';
    }
    if (job.jobPostingType === '02' || job.jobPostingType === '03') {
        return job.candidatePlacementTypeValue === '00'
            ? 'Full Time Contract Job'
            : 'Part Time Contract Job';
    }
    return '';
}
// return CatergoryLabel value if exists
export const getCategoryLabel = (job): string => {
    if (vxm.jobs.BrandingInfo.DISPLAY_JOB_CATEGORY_IN_JOB_CARD && job.categoryLabels) {
        return job.categoryLabels;
    }
    return '';
}

// Validate Job Placement Type and return the right text
export const getJobPayUnit = (job): string => {
    if (job.jobPayUOMText) {
        return job.jobPayUOMText;
    }
    return '';
}